import React, { useContext, useEffect, useState } from 'react';
// import classNames from 'classnames';
// import { useTranslation } from 'react-i18next';
import Brand from '../../../layout/Brand/Brand';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import {
	// componentPagesMenu,
	// dashboardPagesMenu,
	// demoPagesMenu,
	// gettingStartedPagesMenu,
	// pageLayoutTypesPagesMenu,
	companyPagesMenu,
	freelancePagesMenu,
} from '../../../menu';
import ThemeContext from '../../../contexts/themeContext';
// import Card, { CardBody } from '../../../components/bootstrap/Card';
// import Hand from '../../../assets/img/hand.png';
// import HandWebp from '../../../assets/img/hand.webp';
// import Icon from '../../../components/icon/Icon';
// import Button from '../../../components/bootstrap/Button';
// import useDarkMode from '../../../hooks/useDarkMode';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import AuthContext from '../../../contexts/authContext';
import { UserType } from '../../../common/data/dummyRolesData';
import { useOrganization } from '../../../contexts/organizationContext';

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);
	const { userData } = useContext(AuthContext);
	const { organizations } = useOrganization();

	// const [doc, setDoc] = useState(
	// 	localStorage.getItem('facit_asideDocStatus') === 'true' || false,
	// );

	// const { t } = useTranslation(['translation', 'menu']);

	// const { darkModeStatus } = useDarkMode();

	const PROFILE_KEY = 'opentalents_profile_completed';

	const [profileComplete, setProfileComplete] = useState(
		typeof window !== 'undefined' && localStorage.getItem(PROFILE_KEY) === 'true',
	);

	useEffect(() => {
		const syncFromStorage = () => {
			setProfileComplete(localStorage.getItem(PROFILE_KEY) === 'true');
		};

		const onProfileChanged = (e: Event) => {
			// if event carries detail, prefer it; otherwise fallback to storage
			const detail = (e as CustomEvent)?.detail;
			if (detail && typeof detail.complete === 'boolean') {
				setProfileComplete(!!detail.complete);
			} else {
				syncFromStorage();
			}
		};

		const onStorage = (e: StorageEvent) => {
			if (e.key === PROFILE_KEY) syncFromStorage();
		};

		// initial sync + listeners
		syncFromStorage();
		window.addEventListener('profile-completion-changed', onProfileChanged as EventListener);
		window.addEventListener('storage', onStorage);

		return () => {
			window.removeEventListener(
				'profile-completion-changed',
				onProfileChanged as EventListener,
			);
			window.removeEventListener('storage', onStorage);
		};
	}, []);

	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				{/* {!doc && (
					<>
						<Navigation menu={dashboardPagesMenu} id='aside-dashboard' />
						<NavigationLine />
						<Navigation menu={demoPagesMenu} id='aside-demo-pages' />
						<NavigationLine />
						<Navigation menu={pageLayoutTypesPagesMenu} id='aside-menu' />
					</>
				)} */}

				{/* {doc && (
					<>
						<Navigation menu={gettingStartedPagesMenu} id='aside-docMenu' />
						<NavigationLine />
						<Navigation menu={componentPagesMenu} id='aside-componentsMenu' />
						<NavigationLine />
					</>
				)} */}

				{/* {asideStatus && doc && (
					<Card className='m-3 '>
						<CardBody className='pt-0'>
							<img srcSet={HandWebp} src={Hand} alt='Hand' width={130} height={130} />
							<p
								className={classNames('h4', {
									'text-dark': !darkModeStatus,
									'text-light': darkModeStatus,
								})}>
								{t('Everything is ready!') as ReactNode}
							</p>
							<Button
								color='info'
								isLight
								className='w-100'
								onClick={() => {
									localStorage.setItem('facit_asideDocStatus', 'false');
									setDoc(false);
								}}>
								{t('Demo Pages') as ReactNode}
							</Button>
						</CardBody>
					</Card>
				)} */}

				{/* Compnay Route */}
				{userData.role === UserType.COMPANY && (
					<>
						<Navigation
							menu={
								organizations && organizations.length === 0
									? { Organizations: companyPagesMenu.Organizations }
									: companyPagesMenu
							}
							id='company-dashboard'
						/>
						<NavigationLine />
					</>
				)}

				{/* Freelance Route */}
				{userData.role === UserType.FREELANCE && (
					<>
						<Navigation
							menu={
								profileComplete
									? freelancePagesMenu
									: { Settings: freelancePagesMenu.Settings }
							}
							id='freelance-dashboard'
						/>
						<NavigationLine />
					</>
				)}
			</AsideBody>
			<AsideFoot>
				{/* <nav aria-label='aside-bottom-menu'>
					<div className='navigation'>
						<div
							role='presentation'
							className='navigation-item cursor-pointer'
							onClick={() => {
								localStorage.setItem('facit_asideDocStatus', String(!doc));
								setDoc(!doc);
							}}
							data-tour='documentation'>
							<span className='navigation-link navigation-link-pill'>
								<span className='navigation-link-info'>
									<Icon
										icon={doc ? 'ToggleOn' : 'ToggleOff'}
										color={doc ? 'success' : undefined}
										className='navigation-icon'
									/>
									<span className='navigation-text'>
										{t('menu:Documentation') as ReactNode}
									</span>
								</span>
								<span className='navigation-link-extra'>
									<Icon
										icon='Circle'
										className={classNames(
											'navigation-notification',
											'text-success',
											'animate__animated animate__heartBeat animate__infinite animate__slower',
										)}
									/>
								</span>
							</span>
						</div>
					</div>
				</nav> */}
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
